import { AuthRecord as AuthResponse } from "pocketbase";
import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { pb } from "../utils/pocketbase";

interface UserContextContent {
  user?: AuthResponse;
  signOut: () => void;
};

const UserContext = createContext<UserContextContent | undefined>(undefined);

export const UserContextProvider = (p: { children: React.ReactNode }) => {
  const [user, setUser] = useState<AuthResponse>();

  // user
  useEffect(() => {
    if (pb.authStore.isValid) {
      setUser(pb.authStore.record)
    }

    pb.authStore.onChange(() =>
      setUser(pb.authStore.isValid ? pb.authStore.record : undefined)
    )
  }, []);

  const signOut = useCallback(() => {
    pb.authStore.clear();
  }, []);

  return (
    <UserContext.Provider value={{ user, signOut }}>
      {p.children}
    </UserContext.Provider>
  );
};

export function useUser() {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
}

export function useAuthenticatedUser() {
  const context = useUser();
  if (!context.user) {
    throw new Error("useAuthenticatedUser must be used within a business owner context")
  }
  return context as Required<UserContextContent>;
}
